import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/highscores.css';
import spiderLogo from '../../assets/images/logo2.png';

const HighScores = () => {
    // Dummy data for high scores
    const highScores = [
        { rank: 1, player: "Master Spider", score: 125000, time: "2:30" },
        { rank: 2, player: "Web Weaver", score: 98000, time: "3:15" },
        { rank: 3, player: "Card King", score: 85000, time: "4:00" },
        { rank: 4, player: "Solitaire Pro", score: 72000, time: "3:45" },
        { rank: 5, player: "Spider Queen", score: 65000, time: "5:20" },
    ];

    return (
        <div className="highscores-container">
            <div className="highscores-content">
                <div className="logo-container">
                    <h1 className="game-title">High Scores</h1>
                    <div className="spider-logo">
                        <img src={spiderLogo} alt="Spider Logo" />
                    </div>
                </div>

                <div className="scores-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Player</th>
                                <th>Score</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {highScores.map((score) => (
                                <tr key={score.rank}>
                                    <td>{score.rank}</td>
                                    <td>{score.player}</td>
                                    <td>{score.score.toLocaleString()}</td>
                                    <td>{score.time}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="menu-buttons">
                    <Link to="/">
                        <button className="menu-btn back-btn">
                            Back to Home
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default HighScores; 